module.exports = __webpack_public_path__ + "static/Head-460b2ab5b776a80c0f33e4e1843818da.png";